import { getCarImageAbsoluteURL, unsubscribeSubscriptions } from './../../../shared/services/util.service';
import { IDashboardVehicle } from './../../../shared/models/dashboard.model';
import { AppointmentService } from './../../../shared/services/appointment.service';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { DateTime } from 'luxon';
import { Observable } from 'rxjs';
import { BdcDashboardState } from './../../../store/bdcdashboard/bdcdashboard.reducer';
import { Store } from '@ngrx/store';
import { selectIsBeingCancelledByAppointmentId } from './../../../store/bdcdashboard/bdcdashboard.selectors';
import { AppointmentBookingSource, AppointmentStatus, AppointmentType, LocationType } from '@signal/asp-data-commons';
import { DealerState } from './../../../store/dealer/dealer.reducer';
import * as fromSelectors from './../../../store/dealer/dealer.selectors';
import * as util from './../../../shared/services/util.service';
import { TranslateService } from '@ngx-translate/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { SubscriptionList } from 'src/app/modules/shared/models/asp.types';
import { VehicleStatus } from '@signal/asp-data-commons/lib/enums/enum';
import {ServiceAppointmentState} from '../../../store/service-appointment/service-appointment.reducer';
import {EditServiceAppointmentFromDashboard} from '../../../store/service-appointment/service-appointment.actions';
import { getDeletePendingForTestdrive } from 'src/app/modules/store/sales-appointment/sales-appointment.adapter';

@Component({
  selector: 'app-sales-card',
  templateUrl: './sales-card.component.html',
  styleUrls: ['./sales-card.component.scss'],
})
export class SalesCardComponent implements OnInit, OnChanges, OnDestroy {
  @Input() vehicle: IDashboardVehicle;
  @Input() allInventoryVehicles: any[] = [];
  @Output() appointmentCancel: EventEmitter<void> = new EventEmitter<void>();

  vinDisplayText: string;
  appointmentExists: boolean;
  appointmentDateTime: string;
  carImageAbsoluteURL: string;
  setDefaultImg=util.setDefaultImg;
  carNameDisplayText: string;
  appointmentLocationType: string;
  appointmentLocationAddress: string;
  dateFormat = 'MM-dd-yyyy';
  buttonText: string;
  buttonTextCancel:string;
  flipCancelCard = false;
  isFlipCard = false;
  isSavedForLater = false;
  flipTo = "";
  isAppointmentFlipCard = false;
  isBeingCancelled$: Observable<boolean>;
  from = "";

  hoursOfOperation$: Observable<string>;
  dealerName$: Observable<string>;
  dealerPhone$: Observable<string>;
  dealerAddress$: Observable<string>;
  dealerLatitude$: Observable<number>;
  dealerLongitude$: Observable<number>;
  subscriptions: SubscriptionList = {};
  vehicleStatus:string;
  isNVI:boolean;
  isDisabled=false;
  isDealerSame=true;
  dealerCode$: Observable<string>;
  dealerCode:string;
  isVehicleInquiry=false;
  isSalesAccessible=util.isSalesAccessibleFeatureFlag;
  isServiceAccessible=util.isServiceAccessibleFeatureFlag;
  isPartsAccessible=util.isPartsAccessible;
  isPartsFeatureEnabled=util.environment.enableParts;
  isDeletePending = false;
  showPartsAppointment = true;
  constructor(
    private readonly router: Router,
    private readonly appointmentService: AppointmentService,
    private readonly dashboardState: Store<BdcDashboardState>,
    private readonly dealerState: Store<DealerState>,
    private readonly translate: TranslateService,
    private readonly copy: Clipboard,
    private readonly serviceAppointmentState: Store<ServiceAppointmentState>,
  ) {
    this.getDealerStateValue();
    this.dealerCode$ = this.dealerState.select(fromSelectors.selectDealerCode); 
    this.subscriptions.dealerSubscription=this.dealerCode$.subscribe(code=>{
      this.dealerCode=code;
     });
  }

  ngOnInit(): void {
    this.showPartsAppointment = this.vehicle?.appointment?.appointmentType !== AppointmentType.PARTS
      || this.canAccessParts();
    if (!this.showPartsAppointment) {
      return;
    }

    this.isVehicleInquiry=this.vehicle.appointment.appointmentType === AppointmentType.VEHICLE_INQUIRY;
    if(!this.isVehicleInquiry)
    {
      this.initializeValues();
    }
    this.appointmentExists = !!this.vehicle.appointment;
    this.appointmentDateTime = this.appointmentExists && this.vehicle.appointment.appointmentStatus!=AppointmentStatus.SAVED ? this.getAppointmentDateTime() : '';
    this.getLocationType();
    // TODO - Store generic image URL in prop/env
    if(!this.isVehicleInquiry)
    {
      this.carImageAbsoluteURL = getCarImageAbsoluteURL(this.vehicle.imageUrl);
    }
    this.buttonText = this.getButtonText(this.vehicle.appointment.appointmentType);
    this.buttonTextCancel = this.getButtonTextCancel(this.vehicle.appointment.appointmentType);
    if (this.vehicle.appointment) {
      this.isBeingCancelled$ = this.dashboardState
        .select(selectIsBeingCancelledByAppointmentId,
          { appointmentId: this.vehicle.appointment.appointmentId });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.allInventoryVehicles && !changes.allInventoryVehicles.firstChange && !this.isVehicleInquiry) {
      this.updateDeletePendingStatus();
    }
  }

  initializeValues() {
    this.isDealerSame = this.dealerCode != this.vehicle.dealerCode;
    this.isNVI = this.vehicle.dealerCategory === VehicleStatus.A || this.vehicle.dealerCategory === VehicleStatus.G || this.vehicle.dealerCategory === VehicleStatus.F;
    if (this.vehicle.dealerCategory === VehicleStatus.A) {
      this.vehicleStatus = 'otherTexts.allocated';
    }
    else if (this.vehicle.dealerCategory === VehicleStatus.F) {
      this.vehicleStatus = 'otherTexts.inTransit';
    }
    else {
      this.vehicleStatus = 'otherTexts.ground';
    }
    this.isSavedForLater = this.vehicle.appointment.appointmentStatus === AppointmentStatus.SAVED;
    this.isDisabled = (this.vehicle.dealerCategory === VehicleStatus.A || this.vehicle.dealerCategory === VehicleStatus.F || this.vehicle.isSafetyCampaign) || false;
    this.vinDisplayText = `VIN ${this.vehicle.vin || this.translate.instant('testDrive.notAvailable')}`;
    this.carNameDisplayText = this.getCarNameDisplayText();
    this.updateDeletePendingStatus();
  }

  private updateDeletePendingStatus(): void {
    this.isDeletePending = getDeletePendingForTestdrive(this.vehicle?.appointment, this.allInventoryVehicles || []);
  }

  private getCarNameDisplayText(): string {
    const description = this.sanitizeText(this.vehicle?.description);
    const make = this.sanitizeText(this.vehicle?.make);
    const model = this.sanitizeText(this.vehicle?.model);

    if (description && ![AppointmentType.LEARNING, AppointmentType.PARTS].includes(this.vehicle?.appointment?.appointmentType)) {
      return description;
    }

    const combined = [make, model].filter(Boolean).join(' ').trim();
    return combined || description || '';
  }

  private sanitizeText(value: unknown): string {
    return typeof value === 'string' && value !== 'undefined' && value !== 'null' && value.includes('undefined') === false ? value.trim() : '';
  }

  getLocationType() {
    if (this.vehicle.appointment) {
      if(this.vehicle.appointment.appointmentStatus===AppointmentStatus.SAVED && this.vehicle.appointment.transportationTypeCode === "DEALER")
      {
        this.appointmentLocationType = "At Dealership";
        this.getDealerAddress();
      }else if(this.vehicle.appointment.appointmentStatus==AppointmentStatus.SAVED && this.vehicle.appointment.transportationTypeCode === "REMOTE")
      {
        this.appointmentLocationType = "At Remote";
        this.getDealerAddress();
      }
      else{
        this.appointmentLocationType = this.vehicle.appointment.transportation?.category;
        this.getDealerAddress();
      }
    }
}

  getDealerAddress() {
    if (this.appointmentLocationType) {
      if (LocationType.DEALER === this.appointmentLocationType) {
        if(this.vehicle.appointment.appointmentStatus==AppointmentStatus.SAVED)
        {
          const deliveryAddress=this.vehicle.appointment.dropOffAddress;
          this.appointmentLocationAddress = `${deliveryAddress.addressLine1}, ${deliveryAddress.city}, ${deliveryAddress.state} ${deliveryAddress.zip}`;
        }else{
          const dealer = this.vehicle.appointment.dealer;
          this.appointmentLocationAddress = `${dealer.address.addressLine1}, ${dealer.address.city}, ${dealer.address.state} ${dealer.address.zip}`;
        }
      } else if(LocationType.REMOTE === this.appointmentLocationType){
        if(this.vehicle.appointment.appointmentStatus==AppointmentStatus.SAVED)
        {
          const deliveryAddress=this.vehicle.appointment.dropOffAddress;
          this.appointmentLocationAddress = `${deliveryAddress.addressLine1}, ${deliveryAddress.city}, ${deliveryAddress.state} ${deliveryAddress.zip}`;
        }else{
          const address = this.vehicle.appointment.dropOffAddress;
          this.appointmentLocationAddress = `${address.addressLine1}, ${address.city}, ${address.state} ${address.zip}`;
        }
      }
      else {
        const customer = this.vehicle.appointment.customer?.address;
        this.appointmentLocationAddress = customer?.addressLine1 + ', ' + (customer?.addressLine2 ? customer.addressLine2 +
          ', ' : '') + customer?.city + ', ' + customer?.state + ' - ' + customer?.zip;
      }
    }
  }

  onHoverDialer() {
    
  }

  isMyKarmaAppointment(): boolean {
    return this.vehicle.appointment?.appointmentBookingSource === AppointmentBookingSource.MYKARMA;
  }

  onEditAppointment() {
    if (this.vehicle.appointment.appointmentType === AppointmentType.TEST_DRIVE) {
      this.router.navigate(['asp/bdc/testdrive'], {
        queryParams: {
          id: this.vehicle.appointment.appointmentId,
          email: this.vehicle.appointment.emailAddress
        }
      });
    }
    if (this.vehicle.appointment.appointmentType === AppointmentType.DELIVERY) {
      this.router.navigate(['asp/bdc/delivery'], {
        queryParams: {
          id: this.vehicle.appointment.appointmentId,
          email: this.vehicle.appointment.emailAddress,
          from: this.from
        }
      });
    }
    if (this.vehicle.appointment.appointmentType === AppointmentType.LEARNING) {
      this.router.navigate(['asp/bdc/tech-appointment'], {
        queryParams: {
          id: this.vehicle.appointment.appointmentId,
          email: this.vehicle.appointment.emailAddress
        }
      });
    }
    if (this.vehicle.appointment.appointmentType === AppointmentType.VEHICLE_INQUIRY) {
      this.router.navigate(['asp/bdc/vehicleinquiry'], {
        queryParams: {
          id: this.vehicle.appointment.appointmentId,
          email: this.vehicle.appointment.emailAddress
        }
      });
    }
    if(this.vehicle.appointment.appointmentType === AppointmentType.SERVICE){
      const payload = {
        id: this.vehicle.appointment.appointmentId,
      };
      const navigateUrl = 'asp/bdc/service';
      this.serviceAppointmentState.dispatch(new EditServiceAppointmentFromDashboard());
      this.router.navigate([navigateUrl], { queryParams: payload });
    }
    if (this.vehicle.appointment.appointmentType === AppointmentType.PARTS) {
      const payload = {
        id: this.vehicle.appointment.appointmentId,
      };
      this.router.navigate(['/asp/bdc/parts'], { queryParams: payload });
    }
  }

  onCompleteEditAppointment(){
    if(!this.isSavedForLater){
      this.from = "edit"
      this.onEditAppointment()
      return
    }
    this.isFlipCard = true
    this.flipTo = "completeedit-appointments";
    this.isAppointmentFlipCard = !this.isAppointmentFlipCard;
    setTimeout(() => {
      this.buttonText = this.getButtonText(this.vehicle.appointment.appointmentType);
    },250)
  }

  onCancelFlip() {
    this.flipTo = "cancel-appointments";
    this.flipCancelCard = !this.flipCancelCard;
    this.isFlipCard = !this.isFlipCard
  }

  cancelAppointmentFlip(){
    this.flipTo = "";
    this.isFlipCard = false;
    setTimeout(() => {
      this.buttonText = this.getButtonText(this.vehicle.appointment.appointmentType);
    },250)
  }

  getLinkSentStatus(){
    if(this.vehicle?.appointment?.linkSentToCustomerOn?.length > 0){
      const sentDate = DateTime.fromISO(this.vehicle.appointment.linkSentToCustomerOn)
      const todayDate = DateTime.fromISO(new Date().toISOString())

      const diff = todayDate.diff(sentDate, ["years", "months", "days", "hours"])
      const numberOfDays = diff.toObject().days
      if(numberOfDays === 0){
        return `${this.translate.instant('serviceSchedule.linkSent')} ${this.translate.instant('serviceSchedule.today')}`;
      }else{
        return `${this.translate.instant('serviceSchedule.linkSent')} ${numberOfDays} ${numberOfDays > 1 ?  this.translate.instant('serviceSchedule.daysAgo') : this.translate.instant('serviceSchedule.dayAgo')}`;
      }
    }else{
      return '';
    }
  }

  sendLinkToCustomer(){
    this.from = "sendLink"
    this.onEditAppointment()
  }

  editAppointmentFlip(){
    this.from = "edit"
    this.onEditAppointment()
  }

  onCompleteAppointment(){
    this.from = "complete"
    this.onEditAppointment()
  }

  onCancel() {
    const value = undefined;
    this.appointmentCancel.emit(value);
  }

  onCopyDetails() {
    this.copy.copy(this.convertToText());
  }

  convertToText() {
    const objScheduleText = {
    "Test Drive" : this.translate.instant('testDrive.testDriveAppointmentIsScheduledFor'),
    "Parts Pickup" : this.translate.instant('testDrive.serviceAppointmentIsScheduledFor'),
    "Parts" : this.translate.instant('testDrive.serviceAppointmentIsScheduledFor'),
    "Delivery" : this.translate.instant('testDrive.deliveryAppointmentIsScheduledFor'),
    "Learning" : this.translate.instant('testDrive.learningAppointmentIsScheduledFor'),
    "Vehicle Inquiry" : this.translate.instant('vehicleInquiry.inquiryAppointmentIsScheduledFor')
    }

    let text = '';
    if(this.vehicle.appointment.appointmentType !== AppointmentType.VEHICLE_INQUIRY)
    {
      text += `${util.getMakeModelYearText(this.vehicle)}\n`;
      text += `VIN ${this.vehicle.vin || this.translate.instant('service.notAvailable')}`;
    }
    else{
      text += (!this.vehicle.appointment?.vehicleType && !this.vehicle.appointment?.vehiclesOfInterest?.length ) ? `${this.translate.instant('vehicleInquiry.vehiclesOfInterest')}  : ${this.translate.instant('vehicleInquiry.notSpecified')} ,` :
      `${this.translate.instant('vehicleInquiry.vehiclesOfInterest')} : ${util.getVehicleTypeTraslation(this.vehicle.appointment?.vehicleType,this.translate)} ${util.getVehicleDisplayTextForEnquiryAppt(this.vehicle.appointment?.vehiclesOfInterest,this.translate)},`;
    }
    if (this.vehicle.appointment) {
      text += `\n${objScheduleText[this.vehicle.appointment.appointmentType]} ${this.appointmentDateTime}`;
      text += `\n${this.getTranslation(this.appointmentLocationType)}: ${this.appointmentLocationAddress}`;
    }
    return text;
  }

  getDealerStateValue() {
    this.dealerName$ = this.dealerState.select(fromSelectors.selectDealerName);
    this.dealerPhone$ = this.dealerState.select(fromSelectors.selectDealerPhoneNumber);
    this.dealerAddress$ = this.dealerState.select(fromSelectors.selectDealerAddress);
    this.hoursOfOperation$ = this.dealerState.select(fromSelectors.selectSalesOperationalHours);
    this.dealerLatitude$ = this.dealerState.select(fromSelectors.selectLatitude);
    this.dealerLongitude$ = this.dealerState.select(fromSelectors.selectLongitude);
  }

  getAppointmentDateTime(): string {
    return DateTime.fromISO(this.vehicle.appointment.appointmentStartDate).toFormat('MMM dd') + ' at ' +  this.vehicle.appointment.timeSlotId;
  }

  onNavigateToGmap() {
    if (this.vehicle.appointment.dealer && this.isAtDealership) {
      const link = `https://www.google.com/maps?z=12&t=m&q=loc:${this.vehicle.appointment.dealer.latitude}+${this.vehicle.appointment.dealer.longitude}`;
      this.router.navigate([]).then(result => {
        window.open(link, '_blank');
      });
    }
  }

  get isAtDealership(){
    return this.appointmentLocationType === LocationType.DEALER;
  }

  canAccessParts(): boolean {
    return this.isPartsFeatureEnabled && this.isPartsAccessible;
  }

  get isPartsPickupAppointment(): boolean {
    return this.vehicle?.appointment?.appointmentType === AppointmentType.PARTS;
  }

  getAppointmentTypeLabel(appointmentType: string): string {
    return appointmentType === AppointmentType.PARTS ? 'Parts Pickup' : appointmentType;
  }

  getAppointmentTypeClass(appointmentType: string): string {
    if (appointmentType === AppointmentType.PARTS) {
      return 'label-parts';
    }

    switch (appointmentType) {
      case AppointmentType.SERVICE:
        return 'label-service';
      case AppointmentType.TEST_DRIVE:
        return 'label-test-drive';
      case AppointmentType.LEARNING:
        return 'label-learning';
      case AppointmentType.DELIVERY:
        return 'label-delivery';
      case AppointmentType.VEHICLE_INQUIRY:
        return 'label-inquiry';
      default:
        return '';
    }
  }

  isActionDisabled(): boolean {
    const appointmentType = this.vehicle?.appointment?.appointmentType;
    if (appointmentType === AppointmentType.SERVICE) {
      return !this.isServiceAccessible;
    }
    if (appointmentType === AppointmentType.PARTS) {
      return !this.canAccessParts();
    }
    return !this.isSalesAccessible;
  }

  getButtonText(apptType){
    switch(apptType){
      case AppointmentType.SERVICE:{
        return this.translate.instant('testDrive.editAppointment');
      }
      case AppointmentType.PARTS:{
        return this.translate.instant('testDrive.editAppointment');
      }
      case AppointmentType.TEST_DRIVE:{
        return this.translate.instant('testDrive.editTestDriveAppointment');
      }
      case AppointmentType.DELIVERY:{
        return this.vehicle.appointment.appointmentStatus === AppointmentStatus.SAVED ? this.isFlipCard ? this.translate.instant('testDrive.continueDeliveryAppointment') : this.translate.instant('testDrive.continueeditDeliveryAppointment') : this.translate.instant('testDrive.editDeliveryAppointment');
      }
      case AppointmentType.LEARNING: {
        return this.translate.instant('learning.editLearningAppointment');
      }
      case AppointmentType.VEHICLE_INQUIRY: {
        return this.translate.instant('vehicleInquiry.editEnquiryAppointment');
      }
      default:
        return '';
    }
  }
  getButtonTextCancel(apptType){
    switch(apptType){
      case AppointmentType.SERVICE:{
        return this.translate.instant('testDrive.cancelAppointment');
      }
      case AppointmentType.PARTS:{
        return this.translate.instant('testDrive.cancelAppointment');
      }
      case AppointmentType.TEST_DRIVE:{
        return this.translate.instant('testDrive.cancelTestDriveAppointment');
      }
      case AppointmentType.DELIVERY:{
        return this.translate.instant('testDrive.cancelDeliveryAppointment');
      }
      case AppointmentType.LEARNING:{
        return this.translate.instant('learning.cancelLearningAppointment');
      }
      case AppointmentType.VEHICLE_INQUIRY: {
        return this.translate.instant('vehicleInquiry.cancelEnquiryAppointment');
      }
      default:
        return this.translate.instant('testDrive.cancelAppointment');
    }
  }
  getTranslation(appointmentLocationType){
    const value = appointmentLocationType ? appointmentLocationType.replace(' ','') :appointmentLocationType;
    return value ? this.translate.instant(`service.${value.toLowerCase()}`) : appointmentLocationType;
  }

  getDisplayDate(date: string) {
    return DateTime.fromISO(date).toFormat(this.dateFormat);
  }

  ngOnDestroy(){
    unsubscribeSubscriptions(this.subscriptions);
  }
}
